import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO__user_task } from '@shared/dto/user_task/DTO__user_task';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../../_base/createAsyncThunkSafe';
import { STATE__generation } from '../../STATE__generation';

export const remote_user_task_update_name = createAsyncThunkSafe<void, DTO__user_task>(
  ENUM__network_event_client_to_server.USER_TASK_UPDATE_NAME,
  async (user_task, thunkApi) => {
    await send_to_server(ENUM__network_event_client_to_server.USER_TASK_UPDATE_NAME, user_task);
  },
);

export function init_remote_user_task_create(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(remote_user_task_update_name.pending, state => {})
    .addCase(remote_user_task_update_name.rejected, (state, action) => {})
    .addCase(remote_user_task_update_name.fulfilled, (state, action: PayloadAction) => {});
}
